import gql from 'graphql-tag'

export const DeleteCompanyRecruiterMutation = gql`
  mutation deleteCompanyRecruiter($input: DeleteCompanyRecruiterInput!) {
    deleteCompanyRecruiter(input: $input) {
      id
    }
  }
`
